import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader2, Upload } from "lucide-react";

export const ImportPreviewDialog = ({
  open,
  onClose,
  filename,
  groupName,
  items,
  selectedCount,
  allSelected,
  onToggleAll,
  onToggleItem,
  onConfirm,
  confirming,
}) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-lg" data-testid="import-preview-dialog">
      <DialogHeader>
        <DialogTitle>Import-Vorschau</DialogTitle>
        <DialogDescription>
          {items.length} Empfänger in „{filename}" gefunden. Wählen Sie aus, wer in „{groupName}" übernommen werden soll.
        </DialogDescription>
      </DialogHeader>
      <div className="flex items-center justify-between border-b pb-2">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Checkbox checked={allSelected} onCheckedChange={onToggleAll} data-testid="preview-select-all" />
          <span className="cursor-pointer select-none" onClick={onToggleAll}>Alle auswählen</span>
        </div>
        <span className="text-sm text-muted-foreground" data-testid="preview-selected-count">{selectedCount} ausgewählt</span>
      </div>
      <ScrollArea className="max-h-[45vh] pr-3">
        <div className="divide-y">
          {items.map((it) => (
            <label key={it.email} className="flex items-center gap-3 py-2.5 cursor-pointer" data-testid={`preview-item-${it.email}`}>
              <Checkbox checked={it.selected} onCheckedChange={() => onToggleItem(it.email)} data-testid={`preview-checkbox-${it.email}`} />
              <div className="min-w-0 flex-1">
                <p className="font-medium truncate">{it.name || "—"}</p>
                <p className="text-sm text-muted-foreground truncate">{it.email}</p>
              </div>
              {it.exists && <Badge variant="outline" className="text-[10px] shrink-0">bereits vorhanden</Badge>}
            </label>
          ))}
        </div>
      </ScrollArea>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onClose}>Abbrechen</Button>
        <Button type="button" onClick={onConfirm} disabled={confirming || selectedCount === 0} data-testid="preview-confirm-btn">
          {confirming ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
          {selectedCount} importieren
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
